export const publicAssetsUrl =
  'https://storage.googleapis.com/hogarth-24007-a71d-uploads/public_assets';

export const publicAssets = (path: string) => `${publicAssetsUrl}${path}`;
